(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rfp-recent-projects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(vp) {
      var track = vp.querySelector('.rp-track');
      if (!track) return;
      var prev = vp.querySelector('.rp-arrow--prev');
      var next = vp.querySelector('.rp-arrow--next');
      var section = vp.closest('.rp-section');
      var dotsWrap = section ? section.querySelector('.rp-dots') : null;
      var dots = [];

      function step() { return Math.max(track.clientWidth * 0.8, 240); }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      function update() {
        if (!dots.length) return;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        for (var i = 0; i < dots.length; i++) {
          if (i === idx) { dots[i].classList.add('is-active'); }
          else { dots[i].classList.remove('is-active'); }
        }
      }

      function buildDots() {
        if (!dotsWrap) return;
        var pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
        dotsWrap.innerHTML = '';
        dots = [];
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rp-dot';
          (function (idx) {
            b.addEventListener('click', function () {
              track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
            });
          })(i);
          dotsWrap.appendChild(b);
          dots.push(b);
        }
        update();
      }

      track.addEventListener('scroll', update);
      window.addEventListener('resize', buildDots);
      buildDots();
    }

    function boot() {
      var list = document.querySelectorAll('.rp-viewport');
      for (var i = 0; i < list.length; i++) init(list[i]);
    }

    if (document.readyState !== 'loading') { boot(); }
    else { document.addEventListener('DOMContentLoaded', boot); }

    document.addEventListener('shopify:section:load', function (e) {
      var vp = e.target.querySelector('.rp-viewport');
      if (vp) init(vp);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
